(() => {
  const init = (scope = document) => scope.querySelectorAll('[data-fp-nav]').forEach(root => {
    if(root.dataset.ready) return;
    root.dataset.ready = 'true';
    const trigger = root.querySelector('.fp-guided-trigger');
    const panel = root.querySelector('.fp-guided-panel');
    const categories = [...panel.querySelectorAll('.fp-nav-category')];
    const desktop = panel.dataset.mode === 'desktop';
    const groups = [...panel.querySelectorAll('.fp-nav-section')];
    let timer;
    const opened = () => panel.matches(':popover-open');
    const position = () => {
      const header = root.closest('header-component') || document.querySelector('#header-component');
      const bottom = header ? header.getBoundingClientRect().bottom : 90;
      panel.style.setProperty('--fp-nav-top', Math.max(0,Math.min(bottom,160)) + 'px');
    };
    const select = (chosen) => categories.forEach(item => { if(item !== chosen) item.open = false; });
    const close = () => { clearTimeout(timer); if(opened()) panel.hidePopover(); };
    const show = () => { clearTimeout(timer);position();if(!opened())panel.showPopover(); };
    panel.addEventListener('beforetoggle', e => { if(e.newState==='open') position(); });
    panel.addEventListener('toggle', () => {
      trigger.setAttribute('aria-expanded', String(opened()));
      if(opened() && desktop && categories.length && !categories.some(x=>x.open)) categories[0].open=true;
      if(opened() && !desktop) panel.scrollTop=0;
    });
    panel.querySelectorAll('.fp-nav-close').forEach(button => button.addEventListener('click', () => trigger.focus()));
    const occasionToggle = panel.querySelector('[data-fp-occasions]');
    if (occasionToggle) {
      const occasionPanel = document.getElementById(occasionToggle.getAttribute('aria-controls'));
      occasionToggle.addEventListener('click', () => {
        const expanded = occasionToggle.getAttribute('aria-expanded') !== 'true';
        occasionToggle.setAttribute('aria-expanded', String(expanded));
        occasionPanel.hidden = !expanded;
        if (expanded) occasionPanel.scrollIntoView({ block: 'nearest', behavior: 'instant' });
      });
    }
    groups.forEach(group => group.querySelector('summary').addEventListener('click', () => {
      if(!group.open) groups.forEach(other => { if(other !== group) other.open = false; });
    }));
    categories.forEach(item => {
      const summary = item.querySelector('summary');
      summary.addEventListener('click', e => {
        if(desktop && item.open) {e.preventDefault(); return;}
        if(!item.open) select(item);
      });
      summary.addEventListener('pointerenter', e => {
        if(desktop && e.pointerType==='mouse') {select(item);item.open=true;}
      });
      summary.addEventListener('focus', () => { if(desktop) {select(item);item.open=true;} });
    });
    if(desktop){
      trigger.addEventListener('click',e=>{if(e.detail>0 && opened()){e.preventDefault();clearTimeout(timer);}});
      trigger.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse') show();});
      const laterClose=()=>{timer=setTimeout(()=>{if(!panel.contains(document.activeElement)&&document.activeElement!==trigger) close();},220);};
      trigger.addEventListener('pointerleave',laterClose);
      panel.addEventListener('pointerenter',()=>clearTimeout(timer));
      panel.addEventListener('pointerleave',laterClose);
      panel.addEventListener('focusout',()=>setTimeout(()=>{if(!panel.contains(document.activeElement)&&document.activeElement!==trigger)close();},0));
    }
    panel.addEventListener('keydown',e=>{
      if(e.key==='Escape'){close();trigger.focus();}
    });
    panel.querySelectorAll('a').forEach(a=>a.addEventListener('click',close));
    window.addEventListener('resize',close);
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();

